module.exports = __webpack_public_path__ + "54a57c64ca0e1ae5f546c0f2acd24b5f.svg";